import {
  React,
  Component,
} from 'imports/CommonImports';

import {EconomicImpactSlider} from 'imports/ComponentsImports';

import {IconWithTooltip} from 'imports/DesignImports';

import {
  Paper,
  Checkbox,
  Divider,
  SelectField,
  MenuItem,
} from 'material-ui';

import {TooltipIcon} from 'imports/IconsImports';

const styles = {
  container: {
    backgroundColor: '#fbfbfb',
    paddingBottom: '1em'
  },
  header: {
    margin: '0',
    padding: '1em'
  },
  option: {
    paddingLeft: '1em'
  },
  divider: {
    marginTop: '1em 1em 0 1em'
  },
  slider: {
    padding: '0 1em',
  }
}

class FilterSelector extends Component {
  constructor(props){
    super(props);
    this.state = {
      currency: props.currency,
      economicImpact: props.economicImpact,
      solutionType: props.filters.filter((filter) => {
        return filter.filter.name === 'Tipo de solución'
      })[0],
      novelty: props.filters.filter((filter) => {
        return filter.filter.name === 'Grado de novedad'
      })[0],
      benefitType: props.filters.filter((filter) => {
        return filter.filter.name === 'Tipo de beneficio económico'
      })[0],
      solutionTypeAnswers: props.chosenFilters.filter((filter) => {
        return filter.filterName === 'Tipo de solución'
      }).map((answer) => {return answer.optionName}),
      benefitTypeAnswers: props.chosenFilters.filter((filter) => {
        return filter.filterName === 'Tipo de beneficio económico'
      }).map((answer) => {return answer.optionName}),
      noveltyAnswers: props.chosenFilters.filter((filter) => {
        return filter.filterName === 'Grado de novedad'
      }).map((answer) => {return answer.optionName}),
      yearSelection:  parseInt(props.filters.filter((filter) =>{
        return filter.filter.id === 41
      })[0].option.name, 10),
      yearSelections: props.filters.filter((filter) =>{
        return filter.filter.id === 41
      })[0].filter.options
    }
  }

  componentDidMount() {
    this.setState({
      filtered: this.props.filters.filter((filter) => {
        return filter.filter.name === 'Tipo de solución'
      })
    })
    this.props.handleYearChange(this.state.yearSelection);
  }

  componentWillReceiveProps(props) {
    if(props.chosenFilters){
      this.setState({
        solutionTypeAnswers: props.chosenFilters.filter((filter) => {
          return filter.filterName === 'Tipo de solución'
        }).map((answer) => {return answer.optionName}),
        benefitTypeAnswers: props.chosenFilters.filter((filter) => {
          return filter.filterName === 'Tipo de beneficio económico'
        }).map((answer) => {return answer.optionName}),
        noveltyAnswers: props.chosenFilters.filter((filter) => {
          return filter.filterName === 'Grado de novedad'
        }).map((answer) => {return answer.optionName}),
        economicImpact: props.economicImpact,
      });
    }
  }
  render() {
    return (
      <Paper zDepth={1} >
        <div style={styles.container}>
          <h4 style={styles.header}>Tipo de Solución</h4>
          {this.state.solutionType.filter.options.map((option, i) => {
            return(
              <Checkbox
                style={styles.option}
                key={i}
                label={option.name}
                onCheck={() => this.props.handleCheckboxChange({
                  filterId: this.state.solutionType.filter.id,
                  filterName: this.state.solutionType.filter.name,
                  optionId: option.id,
                  optionName: option.name
                })}
                checked={this.state.solutionTypeAnswers.includes(option.name)}
              />
          );
          })}
          <Divider style={styles.divider} />
          <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={styles.header}>Grado de Novedad</h4>
            <IconWithTooltip icon={<TooltipIcon style={{color: '#1b2543'}}/>} tooltip="Nuevo a nivel global implica nuevo a nivel país y para la empresa"/>
          </div>
              {this.state.novelty.filter.options.map((option, i) => {
                return (
                <Checkbox
                  style={styles.option}
                  key={i}
                  label={option.name}
                  onCheck={() => this.props.handleCheckboxChange({
                    filterId: this.state.novelty.filter.id,
                    filterName: this.state.novelty.filter.name,
                    optionId: option.id,
                    optionName: option.name
                  })}
                  checked={this.state.noveltyAnswers.includes(option.name)}
                />
            );
            })}
          <Divider style={styles.divider} />
            <h4 style={styles.header}>Tipo de Beneficio</h4>
            {this.state.benefitType.filter.options.map((option, i) => {
              return(
                <Checkbox
                  style={styles.option}
                  key={i}
                  label={option.name}
                  onCheck={() => this.props.handleCheckboxChange({
                    filterId: this.state.benefitType.filter.id,
                    filterName: this.state.benefitType.filter.name,
                    optionId: option.id,
                    optionName: option.name
                  })}
                  checked={this.state.benefitTypeAnswers.includes(option.name)}
                />
              )
            })}
          <Divider style={styles.divider} />
          <h4 style={styles.header}>Cantidad de años que es considerada innovación</h4>
          <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'0px'}}>
            <SelectField value={this.state.yearSelection} onChange={this.handleYearChange} maxHeight={200} floatingLabelText="Años como innovación">
              <MenuItem value={null} primaryText="" />
              {this.state.yearSelections.map((option) =>{
                return(<MenuItem value={parseInt(option.name, 10)} primaryText={option.name} />)
              })}
            </SelectField>
          <Divider style={styles.divider} />
          <h4>Impacto económico estimado</h4>
          <EconomicImpactSlider
            style={styles.slider}
            economicImpact={this.state.economicImpact}
            currency={this.state.currency}
            handleChange={this.props.handleSliderChange}/>
          </div>
        </div>
      </Paper>
    );
  }

  handleYearChange = (event, index, value) => {
    this.setState({
      yearSelection: value,
      });
    this.props.handleYearChange(value);
  };

  handleRadioChange = (event, value) => {
    let splitedValue = value.split(',');
    this.props.handleRadioChange(
      this.props.chosenFilters.filter((filter) => {
        return filter.filterName === 'Grado de novedad'
    })[0],
    {
      filterId: this.state.novelty.filter.id,
      filterName: this.state.novelty.filter.name,
      optionId: parseInt(splitedValue[0], 10),
      optionName: splitedValue[1]
    });
  }
}

export default FilterSelector;



// WEBPACK FOOTER //
// ./src/components/selection/FilterSelector.js